// extracted by mini-css-extract-plugin
export default {"root":"PreviewTable_root__PKe5S","paper":"PreviewTable_paper__CPAjC","table":"PreviewTable_table__KwQp5"};